export const DEFAULT_LOCALIZATION = {
    supportedLocales: [
        { localeCode: 'en_US', label: 'United States/English' },
    ],
    defaultLocaleCode: 'en_US',
    supportDerivedEnglishLocaleCodes: false
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1sb2NhbGl6YXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL2xvY2FsaXphdGlvbi9kZWZhdWx0LWxvY2FsaXphdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBaUI7SUFDOUMsZ0JBQWdCLEVBQUU7UUFDZCxFQUFDLFVBQVUsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLHVCQUF1QixFQUFDO0tBQ3hEO0lBQ0QsaUJBQWlCLEVBQUUsT0FBTztJQUMxQixnQ0FBZ0MsRUFBRSxLQUFLO0NBQzFDLENBQUEifQ==